export const menuData = [
  {
    title: "BURGER",
    color: "black",
    items: [
      { name: "ALOO TIKKI", price: "59/-" },
      { name: "PANEER BURGER", price: "69/-", isSpecial: true },
      { name: "CHEESE BURGER", price: "79/-" },
      { name: "TANDOORI BURGER", price: "79/-" },
    ],
  },
  {
    title: "PIZZA",
    color: "green",
    items: [
      {
        name: "CHEESE CORN PIZZA",
        price: "170/-",
        description: "(ONION, CAPSICUM, CORN, CHEESE)",
      },
      {
        name: "CLASSIC CHEESE",
        price: "149/-",
        description: "(CHEESE)",
      },
      {
        name: "ITALIAN PIZZA",
        price: "199/-",
        description: "(ONION, TOMATO, CAPSICUM & CHEESE)",
        isSpecial: true,
      },
      {
        name: "VEG TREAT PIZZA",
        price: "229/-",
        description: "(ONION, TOMATO, CAPSICUM, CORN, JALAPINO & CHEESE)",
      },
      {
        name: "PANEER TIKKA PIZZA",
        price: "279/-",
        description: "(PANEER, ONION, CAPSICUM, CORN, BLACK OLIVES, RED PAPRIKA, CHEESE)",
      },
      {
        name: "VEGGIE SUPREME",
        price: "289/-",
        description: "(ONION, CAPSICUM, TOMATO, BLACK OLIVES, BABY CORN & CHEESE)",
      },
    ],
  },
  {
    title: "CHAI",
    color: "black",
    items: [
      { name: "ADARAK CHAI", price: "15/-" },
      { name: "CHOCOLATE CHAI", price: "15/-" },
      { name: "BLACK TEA", price: "15/-" },
      { name: "MASALA CHAI", price: "15/-" },
      { name: "CB SPECIAL CHAI", price: "20/-", isSpecial: true },
    ],
  },
  {
    title: "COFFEE",
    color: "green",
    items: [
      { name: "HOT COFFEE", price: "15/-" },
      { name: "BLACK COFFEE", price: "15/-" },
    ],
  },
  {
    title: "COLD COFFEE",
    color: "green",
    items: [
      { name: "COLD COFFEE", price: "119/-" },
      { name: "ICE CREAM COLD COFFEE", price: "129/-" },
      { name: "STRAWBERRY COLD COFFEE", price: "129/-" },
      { name: "CHOCOLATE COLD COFFEE", price: "139/-" },
      { name: "CHOCOLATE ICE CREAM COLD COFFEE", price: "149/-" },
      { name: "BROWNIE COLD COFFEE", price: "149/-" },
    ],
  },
  {
    title: "SHAKE",
    color: "green",
    items: [
      { name: "OREO SHAKE", price: "119/-" },
      { name: "STRAWBERRY SHAKE", price: "129/-" },
      { name: "KITKAT SHAKE", price: "129/-" },
      { name: "BUTTER SCOTCH", price: "139/-" },
      { name: "MANGO SHAKE", price: "129/-" },
      { name: "KIWI SHAKE", price: "139/-" },
      { name: "ORANGE SHAKE", price: "129/-" },
      { name: "LITCHI", price: "123/-" },
      { name: "BLACK CURRENT", price: "139/-" },
      { name: "PINEAPPLE", price: "149/-" },
      { name: "ROSE MILK", price: "109/-" },
      { name: "BROWNIE SHAKE", price: "149/-" },
    ],
  },
  {
    title: "SANDWICH",
    color: "black",
    items: [
      { name: "MAGGIE SAND", price: "79/-" },
      { name: "VEG CORN SAND", price: "89/-" },
      { name: "CHOCOLATE SAND", price: "99/-" },
      { name: "CHEESE GARLIC SAND", price: "109/-" },
      { name: "CHEESE MAGGIE SAND", price: "109/-" },
      { name: "CHEESE CORN SAND", price: "119/-" },
      { name: "PIZZA ROSTED SAND", price: "129/-" },
      { name: "PANEER TIKKA SAND", price: "139/-" },
      { name: "CHEESE BURST SAND", price: "149/-" },
    ],
  },
  {
    title: "MAGGIE",
    color: "green",
    items: [
      { name: "PLAIN MAGGIE", price: "49/-" },
      { name: "MASALA MAGGIE", price: "59/-" },
      { name: "SCHEZWAN MAGGIE", price: "69/-" },
      { name: "VEG MAGGIE", price: "79/-", isSpecial: true },
      { name: "TANDOORI MAGGIE", price: "89/-" },
      { name: "CHEESE CORN MAGGIE", price: "109/-", isSpecial: true },
      { name: "PANEER MAGGIE", price: "119/-" },
    ],
  },
  {
    title: "ICE CREAM",
    color: "black",
    items: [
      { name: "VANILLA", price: "30/-" },
      { name: "CHOCOLATE", price: "40/-" },
      { name: "BUTTER SCOTCH", price: "45/-" },
    ],
  },
  {
    title: "MOCKTAILS",
    color: "black",
    items: [
      { name: "VIRGIN MOJITO", price: "119/-" },
      { name: "BLUE OCEAN", price: "119/-", isSpecial: true },
      { name: "GREEN SEA", price: "119/-" },
      { name: "WHITE ICELAND", price: "119/-" },
      { name: "LOVE ROSE", price: "119/-" },
      { name: "RED SEA", price: "119/-" },
      { name: "CANDY CRUSH", price: "119/-", isSpecial: true },
      { name: "KIWI", price: "119/-" },
      { name: "STRAWBERRY", price: "119/-" },
      { name: "LITCHI", price: "119/-" },
      { name: "PINEAPPLE BLOSSOM", price: "119/-" },
    ],
  },
  {
    title: "BITES",
    color: "green",
    items: [
      { name: "BUTTER BREAD SLICE", price: "25/-" },
      { name: "SCHEZWAN BREAD SLICE", price: "25/-" },
      { name: "PIZZA FIRE FULKI", price: "40/-", isSpecial: true },
      { name: "CHEESE SCHEZWAN CHIPS", price: "59/-" },
    ],
  },
]
